import { Typography, useTheme } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import { LiteBox } from "../../../../components/lite/LiteBox";
import ProgressBar from "../../../../components/ProgressBar";
import refundStyles from "./refunds/refund-styles";

interface ITransactionProgressBarProps {
	reviewedCount: number;
	declinedCount: number;
	acceptedCount: number;
	total: number;
	smaller?: boolean;
}

export const TransactionProgressBar = ({ acceptedCount, declinedCount, reviewedCount, total, smaller }: ITransactionProgressBarProps) => {
	const { t } = useTranslation();
	const { spacing } = useTheme();
	const { reviewedTransactions } = refundStyles();

	return (
		<LiteBox className={reviewedTransactions}>
			<LiteBox>
				<Typography noWrap style={{ fontWeight: 600 }}>{`${t("reviewed-transactions")}:`}</Typography>
			</LiteBox>
			<LiteBox display="flex">
				<Typography>{reviewedCount}</Typography>
				<Typography color="textSecondary">{`/${total}`}</Typography>
			</LiteBox>
			<LiteBox width={smaller ? spacing(8) : spacing(20)}>
				<ProgressBar declined={declinedCount} accepted={acceptedCount} total={total} progress={reviewedCount} />
			</LiteBox>
		</LiteBox>
	);
};
